import dayjs, {Dayjs} from 'dayjs';

export const CURRENCY = 'EUR';

/**
 * Дашборд грузит максимум 1 год за раз (задача #70) — более широкий диапазон
 * кладёт бэкенд на больших объёмах.
 */
export const MAX_RANGE_YEARS = 1;

export const isRangeTooLong = (
  start: Dayjs | null,
  end: Dayjs | null,
): boolean => {
  if (!start || !end || !start.isValid() || !end.isValid()) return false;
  return end.startOf('day').isAfter(start.startOf('day').add(MAX_RANGE_YEARS, 'year'));
};

// Неделя считается с понедельника (dayjs по умолчанию берёт воскресенье).
const startOfWeek = (date: Dayjs): Dayjs =>
  date.subtract((date.day() + 6) % 7, 'day').startOf('day');

export interface DatePreset {
  label: string;
  getRange: () => {start: Dayjs; end: Dayjs};
}

export const DATE_PRESETS: DatePreset[] = [
  {
    label: 'This week',
    getRange: () => ({start: startOfWeek(dayjs()), end: dayjs().endOf('day')}),
  },
  {
    label: 'Last week',
    getRange: () => {
      const lastWeekStart = startOfWeek(dayjs()).subtract(7, 'day');
      return {start: lastWeekStart, end: lastWeekStart.add(6, 'day').endOf('day')};
    },
  },
  {
    label: 'Last 7 days',
    getRange: () => ({
      start: dayjs().subtract(6, 'day').startOf('day'),
      end: dayjs().endOf('day'),
    }),
  },
  {
    label: 'This month',
    getRange: () => ({
      start: dayjs().startOf('month'),
      end: dayjs().endOf('day'),
    }),
  },
  {
    label: 'Past month',
    getRange: () => {
      const prevMonth = dayjs().subtract(1, 'month');
      return {start: prevMonth.startOf('month'), end: prevMonth.endOf('month')};
    },
  },
  {
    label: 'Last 30 days',
    getRange: () => ({
      start: dayjs().subtract(29, 'day').startOf('day'),
      end: dayjs().endOf('day'),
    }),
  },
];

export const formatCurrency = (value: number | undefined | null): string =>
  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: CURRENCY,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value ?? 0);

// short form for chart axes, e.g. €5k, €1.2k
export const formatCurrencyCompact = (
  value: number | undefined | null,
): string =>
  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: CURRENCY,
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value ?? 0);

// cash, cards, other
export const PAYMENT_COLORS = ['#22C55E', '#6366F1', '#F59E0B'];

export const SERIES_COLORS = {
  current: '#22C55E',
  previous: '#6366F1',
};
